import React from 'react';
// import PropTypes from 'prop-types';

// Components
// SVGs
// Images
// Constants
import { socialData } from 'constants/constants';
// Styles
import './Footer.css';

export default class Footer extends React.Component {
  // Prop Types
  // ------------------------------------------------------------------------ //
  static propTypes = {};
  static defaultProps = {};

  // Constructor
  // ------------------------------------------------------------------------ //
  // constructor(props) {
  //   super(props);
  // }

  // Variables
  // ------------------------------------------------------------------------ //

  // Lifecycle methods
  // ------------------------------------------------------------------------ //

  // Event handlers
  // ------------------------------------------------------------------------ //

  // Class methods
  // ------------------------------------------------------------------------ //

  // Render methods
  // ------------------------------------------------------------------------ //
  renderSocials = () => {
    return socialData.map(social => (
      <li key={social.title}>
        <a target="_blank" href={social.url} rel="noopener noreferrer">
          <img src={social.image} alt={`social link ${social.title}`}/>
        </a>
      </li>
    ))
  }
  render() {
    return (
      <div className="footer">
        <a target="_blank" href="https://www.artworxla.org/"  rel="noopener noreferrer"><p>&copy;2018 artworxLA</p></a>
        <ul className="footer__socials">
          {this.renderSocials()}
        </ul>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js